import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '@web/molecules/index.js';
import {
  StyledQuizCallout,
  Headline,
  Subheadline,
  Attribute,
  Content,
} from './styles.js';

export const QuizCallout = ({
  headline,
  subheadline,
  attribute,
  icon,
  fontColor = 'secondary.plum',
  backgroundColor = 'background.lightest',
  hideCallout = false,
  margin = [6, 0],
}) => {
  return (
    <StyledQuizCallout
      $margin={margin}
      $hideCallout={hideCallout}
      $bgColor={backgroundColor}
      $fontColor={fontColor}
    >
      <ResponsiveImage
        src={icon.src}
        alt={icon.alt}
        height={48}
        width={48}
      ></ResponsiveImage>
      <Content>
        {headline && <Headline>{headline}</Headline>}
        {subheadline && <Subheadline>{subheadline}</Subheadline>}
        {attribute && <Attribute>{attribute}</Attribute>}
      </Content>
    </StyledQuizCallout>
  );
};
QuizCallout.displayName = 'QuizCallout';

QuizCallout.propTypes = {
  headline: PropTypes.string,
  subheadline: PropTypes.string,
  attribute: PropTypes.string,
  icon: PropTypes.object.isRequired,
  fontColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  hideCallout: PropTypes.bool,
  margin: PropTypes.arrayOf(PropTypes.number),
};
